module.exports = __webpack_public_path__ + "img/light2.efd00d0c.png";